import React, { useEffect, useState } from "react";
import { Table, Card, Tag, Space, Typography } from "antd";
import { WalletOutlined } from "@ant-design/icons";
import { getAdminWallets } from "../../api/parkpass/parkpassWallets";

const { Title } = Typography;

const CitizenWalletsPage = () => {
  const [wallets, setWallets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  useEffect(() => {
    fetchWallets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchWallets = async (page = 1, pageSize = 25) => {
    try {
      setLoading(true);
      const response = await getAdminWallets({ page, pageSize });
      setWallets(response.items || []);
      setPagination({
        current: response.page || 1,
        pageSize: response.page_size || pageSize,
        total: response.total || 0,
      });
    } catch (error) {
      console.error("Error fetching wallets:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (newPagination) => {
    fetchWallets(newPagination.current, newPagination.pageSize);
  };

  const columns = [
    {
      title: "Wallet ID",
      dataIndex: "wallet_id",
      key: "wallet_id",
      width: 100,
    },
    {
      title: "Utilisateur",
      key: "user",
      width: 250,
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>
            {record.user_full_name ||
              `${record.user_first_name || ""} ${record.user_last_name || ""}`.trim() ||
              "N/A"}
          </div>
          {record.user_email && (
            <div style={{ fontSize: 12, color: "#999" }}>{record.user_email}</div>
          )}
          <div style={{ fontSize: 11, color: "#bbb" }}>User ID: {record.user_id}</div>
        </div>
      ),
    },
    {
      title: "Solde",
      dataIndex: "balance",
      key: "balance",
      width: 130,
      render: (balance) => (
        <span style={{ fontWeight: 600, color: "#52c41a" }}>
          {parseFloat(balance || 0).toFixed(2)} MAD
        </span>
      ),
    },
    {
      title: "Solde Bloqué",
      dataIndex: "locked_balance",
      key: "locked_balance",
      width: 130,
      render: (locked) => (
        <span style={{ fontWeight: 600, color: locked > 0 ? "#fa8c16" : "#999" }}>
          {parseFloat(locked || 0).toFixed(2)} MAD
        </span>
      ),
    },
    {
      title: "Solde Disponible",
      dataIndex: "available_balance",
      key: "available_balance",
      width: 140,
      render: (available) => (
        <Tag color={available > 0 ? "green" : "default"}>
          {parseFloat(available || 0).toFixed(2)} MAD
        </Tag>
      ),
    },
    {
      title: "Date de création",
      dataIndex: "created_at",
      key: "created_at",
      width: 160,
      render: (date) => (date ? new Date(date).toLocaleString("fr-FR") : "N/A"),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Card
        title={
          <Space>
            <WalletOutlined />
            <Title level={4} style={{ margin: 0 }}>
              Portefeuilles Citizen
            </Title>
          </Space>
        }
      >
        <Table
          columns={columns}
          dataSource={wallets}
          rowKey="wallet_id"
          loading={loading}
          pagination={{
            ...pagination,
            showSizeChanger: true,
            showTotal: (total) => `Total: ${total} portefeuilles`,
            pageSizeOptions: ["10", "25", "50", "100"],
          }}
          onChange={handleTableChange}
          scroll={{ x: 900 }}
        />
      </Card>
    </div>
  );
};

export default CitizenWalletsPage;
